import { PixelType } from "./types";
export const PIXEL_TYPE_OPTIONS = [
    { id: PixelType.STATIC, label: "Static Pixel" },
    { id: PixelType.UNIVERSAL, label: "Universal Pixel" }
];
export var UniversalPixelEventType;
(function (UniversalPixelEventType) {
    UniversalPixelEventType["PAGE_VIEWS"] = "page_views";
    UniversalPixelEventType["LEADS"] = "leads";
    UniversalPixelEventType["PURCHASES"] = "purchases";
})(UniversalPixelEventType || (UniversalPixelEventType = {}));
export const UNIVERSAL_PIXEL_EVENT_TYPES = Object.values(UniversalPixelEventType);
export var UniversalPixelEventSubtype;
(function (UniversalPixelEventSubtype) {
    UniversalPixelEventSubtype["PAGE_VIEW"] = "page_view";
    UniversalPixelEventSubtype["MANUAL_FORMSUBMIT"] = "manual_formsubmit";
    UniversalPixelEventSubtype["CONTACT"] = "contact";
    UniversalPixelEventSubtype["ADDTOCART"] = "addtocart";
    UniversalPixelEventSubtype["PURCHASE"] = "purchase";
})(UniversalPixelEventSubtype || (UniversalPixelEventSubtype = {}));
export const UNIVERSAL_PIXEL_EVENT_SUBTYPES = {
    [UniversalPixelEventType.PAGE_VIEWS]: [UniversalPixelEventSubtype.PAGE_VIEW],
    [UniversalPixelEventType.LEADS]: [
        UniversalPixelEventSubtype.MANUAL_FORMSUBMIT,
        UniversalPixelEventSubtype.CONTACT,
        UniversalPixelEventSubtype.ADDTOCART
    ],
    [UniversalPixelEventType.PURCHASES]: [UniversalPixelEventSubtype.PURCHASE]
};
export const UNIVERSAL_PIXEL_EVENT_TYPE_LABELS = {
    [UniversalPixelEventType.PAGE_VIEWS]: "Page Views",
    [UniversalPixelEventType.LEADS]: "Leads",
    [UniversalPixelEventType.PURCHASES]: "Purchases"
};
export const UNIVERSAL_PIXEL_EVENT_SUBTYPE_LABELS = {
    [UniversalPixelEventSubtype.PAGE_VIEW]: "Page View",
    [UniversalPixelEventSubtype.MANUAL_FORMSUBMIT]: "Form Submission",
    [UniversalPixelEventSubtype.CONTACT]: "Contact",
    [UniversalPixelEventSubtype.ADDTOCART]: "Add to Cart",
    [UniversalPixelEventSubtype.PURCHASE]: "Purchases"
};
const STRING_OPERATORS = ["=", "!=", "contains", "not_contains"];
const NUMERIC_OPERATORS = ["=", "!=", ">=", "<=", ">", "<"];
// Add to Cart's currency is intentionally excluded as a filterable field.
export const PARAMETER_FIELDS_BY_SUBTYPE = {
    [UniversalPixelEventSubtype.PAGE_VIEW]: [
        {
            field: "url",
            label: "Page URL",
            type: "STRING",
            operators: STRING_OPERATORS,
            inputType: "TEXT"
        },
        {
            field: "referrer",
            label: "Page Referrer",
            type: "STRING",
            operators: STRING_OPERATORS,
            inputType: "TEXT"
        }
    ],
    [UniversalPixelEventSubtype.MANUAL_FORMSUBMIT]: [
        {
            field: "form_action_id",
            label: "Form ID",
            type: "STRING",
            operators: STRING_OPERATORS,
            inputType: "TEXT"
        },
        {
            field: "event_label",
            label: "Form Name",
            type: "STRING",
            operators: STRING_OPERATORS,
            inputType: "TEXT"
        },
        {
            field: "dest_url",
            label: "Form Destination",
            type: "STRING",
            operators: STRING_OPERATORS,
            inputType: "TEXT"
        }
    ],
    [UniversalPixelEventSubtype.CONTACT]: [
        {
            field: "click_text",
            label: "Click Text",
            type: "STRING",
            operators: STRING_OPERATORS,
            inputType: "TEXT"
        },
        {
            field: "dest_url",
            label: "Click URL",
            type: "STRING",
            operators: STRING_OPERATORS,
            inputType: "TEXT"
        },
        {
            field: "event_label",
            label: "Event Label",
            type: "STRING",
            operators: STRING_OPERATORS,
            inputType: "TEXT"
        },
        {
            field: "contact_type",
            label: "Contact Type",
            type: "STRING",
            operators: ["="],
            inputType: "SELECT",
            options: [
                { value: "phone", label: "Phone" },
                { value: "email", label: "Email" },
                { value: "chat", label: "Chat" },
                { value: "Click To Call", label: "Click To Call" }
            ]
        }
    ],
    [UniversalPixelEventSubtype.ADDTOCART]: [
        {
            field: "item_name",
            label: "Item Name",
            type: "STRING",
            operators: STRING_OPERATORS,
            inputType: "TEXT"
        },
        {
            field: "item_id",
            label: "Item ID",
            type: "STRING",
            operators: STRING_OPERATORS,
            inputType: "TEXT"
        },
        {
            field: "value",
            label: "Value",
            type: "NUMERIC",
            operators: NUMERIC_OPERATORS,
            inputType: "CURRENCY"
        }
    ],
    [UniversalPixelEventSubtype.PURCHASE]: [
        {
            field: "order_id",
            label: "Transaction ID",
            type: "STRING",
            operators: STRING_OPERATORS,
            inputType: "TEXT"
        },
        {
            field: "order_revenue",
            label: "Value",
            type: "NUMERIC",
            operators: NUMERIC_OPERATORS,
            inputType: "CURRENCY"
        }
    ]
};
export const OPERATOR_LABELS = {
    "=": "Equals (=)",
    "!=": "Does Not Equal (!=)",
    ">=": "Greater Than or Equal (>=)",
    "<=": "Less Than or Equal (<=)",
    ">": "Greater Than (>)",
    "<": "Less Than (<)",
    contains: "Contains",
    not_contains: "Does Not Contain"
};
//# sourceMappingURL=eventConfig.js.map